import { Components, Theme } from '@mui/material';

export const buildMuiChipComponent = (): Components<Omit<Theme, 'components'>>['MuiChip'] => ({
  styleOverrides: {
    root: {
      minHeight: '26px',
      padding: '4px 8px',
    },
    sizeMedium: {
      maxHeight: '26px',
    },
    icon: {
      margin: '0px',
      marginRight: '5px',
      fontSize: '1.2rem',
    },
    label: ({ theme }) => ({
      padding: '0px',
      fontFamily: theme.typography.fontFamily,
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '150%',
    }),
    filled: ({ theme }) => ({
      color: theme.palette.common.white,
    }),
    labelSmall: {
      fontSize: '11px',
    },
    labelMedium: {
      fontSize: '12px',
    },
    // eslint-disable-next-line
    // @ts-ignore
    labelLarge: {
      fontSize: '16px',
    },
  },
  defaultProps: {
    color: 'secondary',
  },
});
